import { useEffect, useState } from "react";

export const SIDEBAR_COLOR_MODE = {
  defaultDark: false,
  eventName: "123zap:sidebar-color-mode",
  storageKey: "123zap.sidebarColorMode",
  toggleEnabled: true,
};

export function getAppLayoutBackgroundColor(theme, sidebarDark) {
  if (!theme?.palette) {
    return sidebarDark ? "#18181B" : "#FAFAFA";
  }

  return sidebarDark ? theme.palette.custom.gray[900] : theme.palette.background.default;
}

export function getStoredSidebarDarkMode() {
  if (typeof window === "undefined") return SIDEBAR_COLOR_MODE.defaultDark;

  const storedValue = window.localStorage.getItem(SIDEBAR_COLOR_MODE.storageKey);

  if (storedValue === "dark") return true;
  if (storedValue === "light") return false;

  return SIDEBAR_COLOR_MODE.defaultDark;
}

export function setStoredSidebarDarkMode(isDark) {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(
    SIDEBAR_COLOR_MODE.storageKey,
    isDark ? "dark" : "light"
  );

  window.dispatchEvent(
    new CustomEvent(SIDEBAR_COLOR_MODE.eventName, {
      detail: { isDark },
    })
  );
}

export function useSidebarDarkMode() {
  const [sidebarDark, setSidebarDark] = useState(getStoredSidebarDarkMode);

  useEffect(() => {
    function handleColorModeChange(event) {
      if (typeof event.detail?.isDark === "boolean") {
        setSidebarDark(event.detail.isDark);
        return;
      }

      setSidebarDark(getStoredSidebarDarkMode());
    }

    function handleStorageChange(event) {
      if (event.key === SIDEBAR_COLOR_MODE.storageKey) {
        setSidebarDark(getStoredSidebarDarkMode());
      }
    }

    window.addEventListener(SIDEBAR_COLOR_MODE.eventName, handleColorModeChange);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener(SIDEBAR_COLOR_MODE.eventName, handleColorModeChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return sidebarDark;
}
